var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 21 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.151 16.289a2.036 2.036 0 0 1-2.03-2.03c0-1.117.914-2.03 2.03-2.03 1.117 0 2.03.913 2.03 2.03s-.913 2.03-2.03 2.03m6.091 3.045V9.183H2.06v10.151zm0-12.182c1.117 0 2.03.914 2.03 2.03v10.152c0 1.117-.913 2.03-2.03 2.03H2.06a2.036 2.036 0 0 1-2.03-2.03V9.183c0-1.117.914-2.03 2.03-2.03h1.015v-2.03C3.075 2.28 5.31.045 8.151.045c2.843 0 5.076 2.234 5.076 5.076v2.03zm-6.09-5.075c-1.727 0-3.046 1.32-3.046 3.045v2.03h6.09v-2.03c0-1.726-1.32-3.045-3.045-3.045m12.18 4.06h-2.03v6.091h2.03zm0 8.121h-2.03v2.03h2.03z"
  })));
};
export default SvgLock;